import { IEvent, Queue } from '@cian/event-queue';

import type { JSONValue } from '../../types/jsonValue';

export const getEventQueue = (): Queue<IEvent<string, JSONValue>> => {
  if (typeof window !== 'undefined') {
    return window.eventQueue || (window.eventQueue = new Queue());
  }

  return new Queue();
};
